export default {
	"2452df73ddcc2d463b81cbb716eab2ab": "Hint",
	"218cb5f1a785eed01f250ae57202653d": "Go to the wechat Mini Program for payment",
	"254670231519fcaf766027eff379862a": "The wechat mini-program is about to be redirected"
}
